import React from "react"
import RegisterForm from "../../sections/RegisterForm/RegisterForm"
import "./Register.css"

function Register() {
  return (
    <main className='Register auth-page'>
      <RegisterForm />
    </main>
  )
}

export default Register
